module.exports = __webpack_public_path__ + "static/media/help-center.f580a57c.svg";